export default function HomeCopyController() {

}